import { daysBetween, todayIso, type IsoDate } from '@cattle/money'

import { formatDateShort } from '../lib/format'
import { t } from '../lib/i18n'

/**
 * "Today", "Yesterday", "3 days ago", then a real date.
 *
 * The comparison is against `todayIso()` in Asia/Karachi, never against a UTC
 * timestamp: between midnight and 5am in Pakistan the UTC date is still
 * yesterday, and every row on the access log would read a day late.
 */
export function RelativeTime({
  date,
  time,
  className,
}: {
  date: IsoDate
  /** An optional clock time, shown alongside the day. */
  time?: string
  className?: string
}) {
  const days = daysBetween(date, todayIso())

  const label =
    days <= 0
      ? t('time.today')
      : days === 1
        ? t('time.yesterday')
        : days < 7
          ? t('time.daysAgo', { count: days })
          : formatDateShort(date)

  return (
    <time dateTime={date} className={className} title={formatDateShort(date)}>
      {time ? `${label} ${time}` : label}
    </time>
  )
}
